import { ValidationException } from './validation-exception';

export class ConflictValidationException extends ValidationException {
	constructor(conflictingObject: any | any[]) {
		super(ConflictValidationException.createMessage(conflictingObject));
	}

	private static createMessage(conflictingObject: any | any[]): string {
		if (Array.isArray(conflictingObject)) {
			const serializedObjects = conflictingObject.map((value: any) => JSON.stringify(value));
			return `Completing the operation would result in a conflict with the following objects: ${serializedObjects.join(', ')}.`;
		} 
		else {
			return `Completing the operation would result in a conflict with the following object: ${JSON.stringify(conflictingObject)}.`;
		}
	}
}